import {createFileRoute} from "@tanstack/react-router";
import {ErrorComponent} from "./-errorComponent";
import {NotFoundComponent} from "./-notFoundComponent";
import {PendingComponent} from "./-pendingComponent";
import {z as zod} from "zod";
import {
    getPostLoginRedirectPathFromSearch,
    storePostLoginRedirectPathForOidcState,
} from "~/utilities/postLoginRedirect";
import {generateOidcAuthenticationParameters} from "~/utilities/oidcAuthentication";
import {appendSignInDeepLinkHints} from "~/utilities/signInDeepLink";

const OIDC_CODE_VERIFIER_KEY = "oidc_code_verifier";
const OIDC_STATE_KEY = "oidc_state";

export const Route = createFileRoute("/_withAuthenticationStatus/_notAuthenticated/sign-in")({
    validateSearch: zod.object({
        redirectTo: zod.string().optional().catch(undefined),
    }),
    beforeLoad: async ({context, search, location}) => {
        const {codeChallenge, codeVerifier, state} = await generateOidcAuthenticationParameters();
        const redirectPath = getPostLoginRedirectPathFromSearch({
            intellsysBaseUrl: context.intellsysBaseUrl,
            search: search,
        });

        sessionStorage.setItem(OIDC_CODE_VERIFIER_KEY, codeVerifier);
        sessionStorage.setItem(OIDC_STATE_KEY, state);
        storePostLoginRedirectPathForOidcState({
            intellsysBaseUrl: context.intellsysBaseUrl,
            redirectPath: redirectPath,
            state: state,
        });

        const authorizeUrl = new URL("/oauth/authorize", context.oidcAuthorizeBaseUrl);
        authorizeUrl.searchParams.set("response_type", "code");
        authorizeUrl.searchParams.set("client_id", context.oidcClientId);
        authorizeUrl.searchParams.set("redirect_uri", `${context.intellsysBaseUrl}/auth-callback`);
        authorizeUrl.searchParams.set("scope", "openid offline_access profile");
        authorizeUrl.searchParams.set("state", state);
        authorizeUrl.searchParams.set("code_challenge", codeChallenge);
        authorizeUrl.searchParams.set("code_challenge_method", "S256");
        appendSignInDeepLinkHints({
            authorizeUrl,
            searchParams: new URLSearchParams(location.searchStr),
        });

        window.location.href = authorizeUrl.toString();

        // Suspend navigation while the hard redirect above takes effect.
        return new Promise(() => {});
    },
    loader: async () => {},
    errorComponent: ErrorComponent,
    notFoundComponent: NotFoundComponent,
    pendingComponent: PendingComponent,
});
